export default __webpack_public_path__ + "static/stacked-column-fae8e07c773db0a7abe720c3215641fc.png";